import { CLEAR_ACTIVE_EXERCISE, FLIP_EXERCISE_ORIENTATION, SELECT_ACTIVE_EXERCISE } from "../actions/types";

const initialState = {
    exercise: null,
}

const userActiveExerciseReducer = (state = initialState, action) => {
    switch (action.type) {
        case SELECT_ACTIVE_EXERCISE:
            return {
                ...state,
                exercise: action.payload,
            };
        case CLEAR_ACTIVE_EXERCISE:
            return {
                ...state,
                exercise: null,
            };
        case FLIP_EXERCISE_ORIENTATION:
            if (state.exercise) {
                return {
                    ...state,
                    exercise: {
                        ...state.exercise,
                        is_flip_orientation: true,
                    },
                };
            }

            return state;
        default:
            return state;
    }
}

export default userActiveExerciseReducer;
